import classNames from 'classnames';
import { memo } from 'react';
import { Icon, IconType } from '../icon/icon.component';
import { Spinner } from '../spinner/spinner.component';
import { Text } from '../text/text.component';
import './buttonInput.component.scss';

export declare namespace ButtonInputType {
  type Props = {
    className?: string | null;
    disabled?: boolean;
    label?: string | null;
    onClick?: () => Promise<unknown>;
    iconLeft?: IconType.Props['variant'];
    iconRight?: IconType.Props['variant'];
    isLoading?: boolean;
    onLoading?: (isLoading: boolean) => void;
    position?: 'top' | 'bottom' | 'left' | 'right';
  };
}

export const ButtonInput = memo(
  ({
    className,
    iconLeft,
    iconRight,
    onClick,
    label,
    disabled = false,
    isLoading = false,
    onLoading,
    position = 'right',
  }: ButtonInputType.Props) => {
    return (
      <div
        className={classNames(
          'buttonInput',
          {
            'buttonInput--no-loading': !isLoading,
            'buttonInput--disabled': disabled,
            'buttonInput--position-top': position === 'top',
            'buttonInput--position-bottom': position === 'bottom',
            'buttonInput--position-left': position === 'left',
            'buttonInput--position-right': position === 'right',
          },
          className,
        )}
        onClick={async () => {
          if (disabled || isLoading) return;

          onLoading?.(true);
          await onClick?.();
          onLoading?.(false);
        }}
      >
        {isLoading && (
          <div className="buttonInput__loading">
            <Spinner variant="dotStream" />
          </div>
        )}
        <div className="buttonInput__content">
          {iconLeft && <Icon variant={iconLeft} color="white_100" />}

          {label && (
            <Text whiteSpace="nowrap" variant="button-s" color="white_100">
              {label}
            </Text>
          )}

          {iconRight && <Icon variant={iconRight} color="white_100" />}
        </div>
      </div>
    );
  },
);
